var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEditarCalendario01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#030104;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1571",
    className: "st0",
    d: "M17.7,30.2H4.2c-0.7,0-1.3-0.6-1.3-1.3V6h26.9v11.3c0.6-0.3,1.2-0.4,1.8-0.4 c0.3,0,0.6,0,0.9,0.1V4.6c0-2.2-1.8-4-4-4H4.2c-2.2,0-4,1.8-4,4v24.2c0,2.2,1.8,4,4,4h12.7L17.7,30.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1573",
    className: "st0",
    d: "M34.5,22l-2-2c-0.6-0.6-1.5-0.6-2,0c0,0,0,0,0,0l-1.6,1.6l4.1,4.1l1.6-1.7 C35.1,23.5,35.1,22.6,34.5,22z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1574",
    className: "st0",
    d: "M20.8,29.5c-0.1,0.1-0.2,0.2-0.2,0.3l-1.4,4.9c-0.1,0.2,0,0.4,0.1,0.6 c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.1,0,0.2,0l4.8-1.4c0.1,0,0.2-0.1,0.3-0.2l6.6-6.6l-4.3-4.3L20.8,29.5z M21.4,33.7l-0.6-0.6 l0.8-2.8l2.1,0.4l0.4,2.1L21.4,33.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4_",
    d: "M21,12.6v-1.4c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.3-0.7,0.7v1.4h-5.5v-1.4c0-0.4-0.3-0.7-0.7-0.7 c-0.4,0-0.7,0.3-0.7,0.7v1.4H12c-1.1,0-2.1,0.9-2.1,2.1c0,0,0,0,0,0l0,0v0.7h13.8v-0.7c0-1.1-0.9-2.1-2.1-2.1H21z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2_3_",
    d: "M10.5,23.7c0.4,0.4,0.9,0.6,1.5,0.6h9.7c1.1,0,2.1-0.9,2.1-2.1l0,0l0,0v-5.5H9.9v5.5 C9.9,22.8,10.1,23.3,10.5,23.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEditarCalendario01);
export default __webpack_public_path__ + "static/media/ico-editar-calendario-01.79bb0259677c859660b2a0b58d9ec357.svg";
export { ForwardRef as ReactComponent };